import React from "react";
import imageUrl from "utils/imageUrl";
import ExploreCollectionCard from "./ExploreCollectionCard";
function ExploreLayout({ data }) {
  return (
    <section className="properties__grid  section__space__top section__space__bottom">
      <div className="container ">
        <div className="properties__grid__area wow fadeInUp">
          <div className="title__with__cta">
            <div className="row d-flex align-items-center">
              <div className="col-lg-12">
                <div className="heading text-center my-5">
                  <h2 className="text-left">Explore All Properties</h2>
                </div>
              </div>
            </div>
          </div>

          {data.map((item, ind) => (
            <ExploreCollectionCard data={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ExploreLayout;
